import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getBazaarVoiceRatings } from '@gcc/pip-components/dist/BazaarVoice';
import { withRouter } from '../../hooks/withRouter';
import Pip from './Pip';
import { getProductDetails, getSampleDetails } from '../../actions/Products';
import history from '../../history';

const mapStateToProps = (state, ownProps) => {
  const {
    config,
    products: { getProductDeatilsStatus, currentProducts },
    countertops: {
      surfaces,
      mobileSideDrawerOpen,
      isProductAvailable,
      currentSurface,
      getCoutnertopSurfacesStatus,
      selectedColor,
    },
    bazaarVoiceRatings: { TotalAnswerCount, TotalQuestionCount, TotalReviewCount, StarRating },
    store: { storeNumber, isStoreEnabled },
    plaConfiguration,
  } = state;

  const { omsId } = ownProps.match;
  const product = currentProducts[omsId];
  const { Attributes = {} } = product || {};

  const { GalleryImages } = state.products.currentProducts[omsId] || {
    ProductName: '',
    Brand: '',
    GalleryImages: [],
  };

  const hideProductSpecifications = Attributes.HideProductSpecifications === 'True';
  const minimumPromoSqFt = Attributes['Minimum Promo Sq Ft'] || 0;

  const ProductDeatilsStatusOK = getProductDeatilsStatus !== 'FAILED';
  const CoutnertopSurfacesStatusOK = getCoutnertopSurfacesStatus !== 'FAILED';
  const isProductInfoAvailable = ProductDeatilsStatusOK && CoutnertopSurfacesStatusOK;
  const { breadcrumbs, useRoomVOIntegration, roomVOIntegrationUrl } = config;

  return {
    currentSurface,
    surfaces,
    sideDrawerIsOpen: mobileSideDrawerOpen,
    config,
    TotalAnswerCount,
    TotalQuestionCount,
    TotalReviewCount,
    StarRating: StarRating || 0,
    isProductAvailable,
    breadcrumbs,
    hideProductSpecifications,
    minimumPromoSqFt,
    isProductInfoAvailable,
    isStoreEnabled,
    storeNumber,
    GalleryImages,
    selectedColor,
    history,
    plaConfiguration,
    useRoomVOIntegration,
    roomVOIntegrationUrl,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSampleDetails,
      getProductDetails,
      getBazaarVoiceRatings,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Pip));
